var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.localAction && !_vm.fetchingAction
        ? _c(
            "overlay",
            {
              attrs: {
                visible: _vm.visible,
                title: _vm.recipientNameAndAccountId,
                "on-close": _vm.handleOverlayClose
              }
            },
            [
              _c(
                "div",
                { staticClass: "phone-button-bar" },
                [
                  _vm.localAction?.status !== "DONE"
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.loading,
                            size: "mini",
                            type: "warning"
                          },
                          on: { click: _vm.onCancelAction }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canExecute(_vm.localAction)
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.loading,
                              size: "mini",
                              type: "success"
                            },
                            on: { click: _vm.handleResolve }
                          },
                          [_vm._v(_vm._s(_vm.$t("resolve")))]
                        )
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.beta && _vm.localAction?.status === "DRAFT"
                    ? _c(
                        "loading-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            execute: _vm.forceCancelAction
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("forcedCancelAction")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.beta &&
                  _vm.localAction &&
                  (_vm.localAction.status === "CANCELED" ||
                    _vm.localAction.status === "DRAFT")
                    ? _c(
                        "loading-button",
                        {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            execute: _vm.forceOpenAction
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("forcedOpenAction")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.queueActive
                    ? [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              disabled: !_vm.queueHasNext || _vm.navigating
                            },
                            on: { click: _vm.navigateNext }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("next")) +
                                "\n\t\t\t\t"
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "queue-position" }, [
                          _vm._v(
                            _vm._s(_vm.queuePosition) +
                              " / " +
                              _vm._s(_vm.queueLength)
                          )
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.localAction?.primary_invoice_by_reference
                ? _c(
                    "div",
                    { staticClass: "disp-flex" },
                    [
                      _c(
                        "el-tag",
                        {
                          staticClass: "ml-auto mb-10",
                          attrs: { type: "warning" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("primaryInvoice")) +
                              " : "
                          ),
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.localAction.primary_invoice_by_reference
                                  .invoice_number
                              )
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    size: "mini",
                    "label-position": "top",
                    rules: _vm.rules
                  }
                },
                [
                  _vm.localAction?.metadata?.channels?.[0]?.hasOwnProperty(
                    "reason"
                  )
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "mr-30",
                          staticStyle: { width: "350px" },
                          attrs: {
                            prop: "reason",
                            label: _vm.$t("reasonForCall")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "3",
                              placeholder: _vm.$t("reason_for_call"),
                              disabled: true
                            },
                            model: {
                              value:
                                _vm.localAction.metadata.channels[0].reason,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localAction.metadata.channels[0],
                                  "reason",
                                  $$v
                                )
                              },
                              expression:
                                "localAction.metadata.channels[0].reason"
                            }
                          })
                        ],
                        1
                      )
                    : _vm.localAction?.metadata?.channels?.[0]?.reason_for_call
                        ?.default_message
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "mr-30",
                          staticStyle: { width: "350px" },
                          attrs: {
                            prop: "reason",
                            label: _vm.$t("reasonForCall")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: "3",
                              placeholder: _vm.$t("reason_for_call"),
                              disabled: true
                            },
                            model: {
                              value:
                                _vm.localAction.metadata.channels[0]
                                  .reason_for_call.default_message,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.localAction.metadata.channels[0]
                                    .reason_for_call,
                                  "default_message",
                                  $$v
                                )
                              },
                              expression:
                                "localAction.metadata.channels[0].reason_for_call.default_message"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "350px" },
                      attrs: { prop: "callResult", label: _vm.$t("callResult") }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("select"),
                            disabled: _vm.localAction?.status === "DONE"
                          },
                          model: {
                            value: _vm.form.callResult,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "callResult", $$v)
                            },
                            expression: "form.callResult"
                          }
                        },
                        _vm._l(_vm.resultCategories, function(item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.translateNoteCategory(item),
                              value: item
                            }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        staticClass: "mt-20",
                        staticStyle: { "max-width": "350px" },
                        attrs: {
                          type: "textarea",
                          rows: "3",
                          disabled: _vm.localAction?.status === "DONE"
                        },
                        model: {
                          value: _vm.form.callResultDescription,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "callResultDescription", $$v)
                          },
                          expression: "form.callResultDescription"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "mb-20" }, [
                _c("span", { staticClass: "bold fc-form-label" }, [
                  _vm._v(_vm._s(_vm.$tc("contact", 777)))
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "contacts-tray" },
                  [
                    _vm.recipient && _vm.recipient.reference
                      ? [
                          _c("contacts", {
                            attrs: {
                              recipient: _vm.recipient.reference,
                              selectable: true,
                              "pre-selected": _vm.preSelectedContacts,
                              disabled: _vm.disabledContacts,
                              "on-select": _vm.handleSelectContact
                            }
                          })
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.fetchingAction
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "min-height": "200px"
              }
            },
            [
              _c("el-loading", {
                attrs: {
                  loading: _vm.fetchingAction,
                  text: "Loading action details..."
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }